module.exports = __webpack_public_path__ + "img/livreur.d64b9ac6.jpg";